import React, { useState } from 'react';

import {
  View,
  Text,
  ScrollView,
  Image,
  FormField,
  LargeButton,
} from '../../app-components';

import {
  getUser,
  mamcResetPasswordWithoutToken,
  mamcResetPassword,
} from '../../AppServices';
import { validateConfirmPassword, validatePassword } from '../../Lib/helpers';
import { TextInput } from '../../app-components/input-components/Editors';
import { Form } from '../../app-components/form/Form';
import { LANDING_VIEW } from '../../Config';

import { appraiseLogo, notificationError } from '../../images';
import vars from '../../theme/vars';
import { isMobile } from '../../app-components/UtilityFunctions';
import { h10_Montessart } from '../../theme/fonts';

const loginStyle = {
  leftSide: {
    display: 'flex',
    width: '35%',
    flexDirection: 'column',
    backgroundColor: '#010101',
    color: 'white',
    padding: '4% 6%',
    justifyContent: 'space-around',
  },

  // scrollViewStyle: {
  //   flex: 1,
  //   justifyContent: 'center',
  //   padding: isMobile && 20,
  //   alignItems: !isMobile && 'center',
  //   backgroundColor: 'rgba(196, 196, 196, 0.01)',
  //   backgroundImage: 'linear-gradient(to top, #fff, #fff8ee)',
  // },

  loginBoxStyle: {
    flex: 1,
    overflow: 'hidden',
    borderColor: vars.colors.white,
  },

  loginText: {
    // marginBottom: !isMobile ? -27 : -17,
    zIndex: 1,
    fontFamily: 'Montessart',
    // fontSize: !isMobile ? 44 : 30,
    color: '#0e0d25',
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 0,
  },
  errorStyle: {
    ...vars.headings.h14,
    color: vars.colors.error,
    textAlign: 'center',
  },
};

export default () => {
  const { loginText, leftSide } = loginStyle;

  return ({ navigation }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const handleSubmit = ({ data }) => {
      const otp =
        navigation?.getParams() &&
        typeof navigation?.getParams() === 'string' &&
        navigation?.getParams().split('#')[1];
      otp
        ? mamcResetPasswordWithoutToken({ ...data, otp }).then((res) => {
            if (res?.message === 'Password changed successfully') {
              navigation.replace('login');
            }
          })
        : mamcResetPassword({ ...data }).then((res) => {
            if (res?.message === 'Password changed successfully') {
              navigation.replace(LANDING_VIEW);
            }
          });
    };
    return (
      <ScrollView>
        <View
          style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
          {/* left side starts */}
          <View style={leftSide}>
            <Image source={appraiseLogo} style={{ width: '170px' }} />
            <Text
              style={{
                fontFamily: 'Poppins',
                fontStyle: 'italic',
                fontSize: '18px',
                color: '#fafafa',
              }}>
              Lorem ipsum dolor sit
            </Text>
            <View style={{ display: 'flex', gap: '30px' }}>
              <Text
                style={{
                  fontFamily: 'Montserrat',
                  fontSize: '36px',
                  color: '#FAFAFA',
                }}>
                Welcome Back!
              </Text>
              <View
                style={{ border: '1px solid #FAFAFA', width: '68.5px' }}></View>
              <Text
                style={{
                  fontFamily: 'Poppins',
                  fontSize: '18px',
                  color: '#FAFAFA',
                  lineHeight: '27px',
                }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna
              </Text>
            </View>
          </View>
          {/* left side over */}
          <View
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              width: '65%',
              flexDirection: !isMobile ? 'row' : 'column',
            }}>
            {/* right side starts */}
            <View>
              <View
                style={{
                  alignItems: 'center',
                }}>
                <Text style={{ ...loginText }}>Reset Password</Text>

                <Text
                  style={{
                    height: 25,
                    fontFamily: 'Nunito',
                    fontSize: 16,
                    color: '#0e0d25',
                    marginTop: !isMobile ? 22 : 15,
                    marginBottom: 30,
                  }}>
                  {getUser()
                    ? 'Your password has expired after first login. Please create a new one.'
                    : 'Please create a new one as you forgot your old password'}
                </Text>
              </View>
              <ScrollView
                style={{
                  overflow: 'hidden',
                  flex: 1,
                  alignItems: !isMobile && 'center',
                }}>
                <Form
                  scrollable
                  mandatory={{
                    newPassword: 'Password is mandatory',
                  }}
                  required={{
                    newPassword: 1,
                    confirmPassword: 1,
                  }}
                  defaultValues={() => {
                    const user = getUser();
                    return {
                      username: user?.username,
                    };
                  }}
                  onSubmit={handleSubmit}
                  containerStyle={{ flex: 1 }}
                  bodyContainerStyle={{
                    margin: 0,
                    flex: 1,
                    overflow: 'hidden',
                  }}
                  validations={{
                    newPassword: ({ data }) =>
                      validatePassword(data.newPassword),
                    confirmPassword: ({ data }) =>
                      validateConfirmPassword(data),
                  }}>
                  <ResetPasswordNew
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                  />
                </Form>
              </ScrollView>
            </View>
          </View>
        </View>
      </ScrollView>
    );
  };
};

const ResetPasswordNew = ({ form_context, errorMessage }) => {
  const { handleSubmit } = form_context;
  const { loginBoxStyle, errorStyle } = loginStyle;

  return (
    <View style={{ ...loginBoxStyle, width: !isMobile && 450 }}>
      {getUser() && (
        <View style={{ marginBottom: 21 }}>
          <FormField
            field="username"
            variant="filled"
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            label={'USERNAME'}
            editable={false}
            style={{
              backgroundColor: vars.colors.grey.color6,
              borderRadius: 10,
              border: '1px solid rgba(152, 152, 178, 0.3)',
            }}>
            <TextInput />
          </FormField>
        </View>
      )}
      <View>
        <FormField
          field="newPassword"
          variant="filled"
          floatingLabelStyle={{
            ...h10_Montessart,
          }}
          activeLabelStyle={{
            ...h10_Montessart,
          }}
          // label="NEW PASSWORD"
          label={'resetPassword.labels.newPassword'.getLabel().toUpperCase()}>
          <TextInput inputProps={{ type: 'password' }} />
        </FormField>
      </View>
      <View style={{ marginTop: 21 }}>
        <FormField
          field="confirmPassword"
          variant="filled"
          floatingLabelStyle={{
            ...h10_Montessart,
          }}
          activeLabelStyle={{
            ...h10_Montessart,
          }}
          label={'resetPassword.labels.confirmPassword'
            .getLabel()
            .toUpperCase()}>
          <TextInput inputProps={{ type: 'password' }} />
        </FormField>
      </View>
      <View
        style={{
          marginTop: 21,
          // textAlign: 'center',
          fontSize: '16px',
          fontFamily: 'Roboto',
        }}>
        <Text
          style={{
            fontStyle: 'italic',
          }}>
          Your password should contain
        </Text>
        <Text
          style={{
            fontStyle: 'italic',
          }}>
          - Minimum 6 and Maximum 30 characters
        </Text>
        <Text
          style={{
            fontStyle: 'italic',
          }}>
          - At least one letter(a-z A-Z), one numeric digit(0-9), and one
          special character.
        </Text>
      </View>
      <View
        style={{
          marginTop: 35,
          marginBottom: 10,
          alignItems: 'center',
        }}>
        <LargeButton
          color="#444444"
          hoverColor={null}
          width="120px"
          label={'resetPassword.buttons.save'.getLabel()}
          labelStyle={{
            fontSize: 16,
            color: '#fff',
            fontFamily: 'Montessart',
          }}
          onClick={handleSubmit}
          height={48}
          borderRadius={100}
        />
      </View>
      {errorMessage ? (
        <View
          style={{
            flexDirection: 'row',
            marginTop: 27,
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Image source={notificationError} style={{ height: 18, width: 18 }} />
          <Text style={{ ...errorStyle }}>{errorMessage}</Text>
        </View>
      ) : null}
    </View>
  );
};
